import { render, staticRenderFns } from "./ComplianceNumberDetails.vue?vue&type=template&id=6524aa22&"
import script from "./ComplianceNumberDetails.vue?vue&type=script&lang=js&"
export * from "./ComplianceNumberDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports